// src/redux/slices/walletSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { gethWalletBalance } from "../../hooks/api/utils";

export const fetchWalletBalance = createAsyncThunk(
  "wallet/fetchBalance",
  async (_, { rejectWithValue }) => {
    try {
      const data = await gethWalletBalance();
      return data.balance ?? 0;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  balance: 0,
  loaded: false,
  status: "idle",
};

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    resetWallet: () => initialState,
    updateWalletBalance: (state, action) => {
      state.balance = action.payload;
      state.loaded = true;
      state.status = "succeeded";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWalletBalance.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWalletBalance.fulfilled, (state, action) => {
        state.balance = action.payload;
        state.loaded = true;
        state.status = "succeeded";
      })
      .addCase(fetchWalletBalance.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export const { resetWallet, updateWalletBalance } = walletSlice.actions;
export default walletSlice.reducer;
